import React from "react";
import { Box, Typography, Stack, TextField, Button } from "@mui/material";
import PaymentsIcon from '@mui/icons-material/Payments';
import SearchIcon from '@mui/icons-material/Search';

type PendingPayoutInvoicesHeaderProps = {
    currency: string;
    fromDate: string;
    setFromDate: (val: string) => void;
    toDate: string;
    setToDate: (val: string) => void;
    onSearch: () => void;
    isLoading: boolean;
};

export const PendingPayoutInvoicesHeader = ({ 
    currency, fromDate, setFromDate, toDate, setToDate, onSearch, isLoading 
}: PendingPayoutInvoicesHeaderProps) => {
    return (
        <Box sx={{ p: 3, borderBottom: '1px solid #e2e8f0', bgcolor: '#f8fafc', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
            <Box>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PaymentsIcon color="primary" /> Pending Operator Payouts
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Search for confirmed invoices awaiting operator transfer for {currency}.
                </Typography>
            </Box>
            
            <Stack direction="row" spacing={2} alignItems="center">
                <TextField label="From" type="date" size="small" value={fromDate} onChange={e => setFromDate(e.target.value)} InputLabelProps={{ shrink: true }} sx={{ width: 135, bgcolor: '#fff' }} />
                <TextField label="To" type="date" size="small" value={toDate} onChange={e => setToDate(e.target.value)} InputLabelProps={{ shrink: true }} sx={{ width: 135, bgcolor: '#fff' }} />
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={onSearch} 
                    disabled={isLoading}
                    startIcon={<SearchIcon />}
                    sx={{ textTransform: 'none', fontWeight: 600, boxShadow: 'none' }}
                >
                    Search
                </Button>
            </Stack>
        </Box>
    );
};